import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { PhotoInfo } from "./PhotoInfo";
import { wsPersonPhotoUploadInfo } from "./wsPersonPhotoUploadInfo";
import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class DataService_batchupload {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	getData
	//
	//-----------------------------------------------------------------------------------------------------
	getData() {
		var postResult$ = new Subject();
		var url = "PhotoID/GetData";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	UploadImages
	//
	//-----------------------------------------------------------------------------------------------------
	UploadImages(SchoolID: number, idx: number, Myimage: PhotoInfo) {
		let obj: wsPersonPhotoUploadInfo = {
			SchoolID: SchoolID,
			idx: idx,
			PhotoName: Myimage.PhotoName,
			PhotoDateTime: Myimage.PhotoDateTime,
			PhotoUrl: Myimage.PhotoUrl,
		};

		var postResult$ = new Subject();
		var url = "PhotoID/UploadPhotos";

		var promise$ = this.httpclientService.post(url, obj);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
